// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202512181033/js/" + chunkId + "." + {"44":"6a0b2c07","225":"e1178b61","481":"82502466","486":"c8a10680","770":"430ba115"}[chunkId] + ".0.3773899341169409.chunk.js";
};